import { Radar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
} from 'chart.js';
import styled from 'styled-components';

ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
);

const SkillsProfile = ({ attributes }) => {

    const data = {
        labels: attributes.map(item => item.name),
        datasets: [
            {
                label: 'Tu desempeño',
                data: attributes.map(item => item.score),
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                borderColor: '#b31d15',
                borderWidth: 2,
            },
        ],
    };

    const options = {
        scales: {
            r: {
                beginAtZero: true,
                min: 0,
                max: 5
            }
        }
    };

    return (
        <Container>
            <h1>Tu perfil de habilidades</h1>
            <section>
                <Radar data={data} options={options} />
            </section>
        </Container>
    )
}

export default SkillsProfile;

const Container = styled.div`
    width: calc(100% - 48px);
    height: fit-content;
    border-radius: 30px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;

    @media (width < 1000px) {
        width: 100%;
    }

    h1 {
        width: 100%;
        text-align: start;
        font-size: 24px;
        font-weight: 700;
    }

    section {
        width: 60%;
            
        @media (width < 1000px) {
            width: 100%;
        }
    }
`
